import { Injectable, inject } from '@angular/core';
import { BaseApiService } from '@bo/ng-api';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { UserOnboardingRequest, UserOnboardingResponse, UserProfile } from '../../_interfaces/user.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseApiService {
  protected override http: HttpClient;

  override baseUrl: string = environment.apiRoot;
  URL_USER: string = 'user';
  URL_USER_ONBOARDING: string = 'user/onboarding';

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }

  getUserDetails(): Observable<UserProfile> {
    return this.http.get<UserProfile>(this.getUrl(this.URL_USER, true));
  }
  getOnboardingDetails(): Observable<UserOnboardingResponse> {
    return this.http.get<UserOnboardingResponse>(this.getUrl(this.URL_USER_ONBOARDING, true));
  }

  updateUserOnboardingStatus(data: UserOnboardingRequest): Observable<UserOnboardingResponse> {
    const url = this.getUrl([this.URL_USER_ONBOARDING], true);
    return this.http.put<UserOnboardingResponse>(url, data);
  }
}
